export default {
  notifications: 'Notifications',
  no_unread_notification: 'No unread notification',
  see_all_notification: 'See all notification',
  see_all: 'See All'
}
